import { render } from "./DailyComponent.vue?vue&type=template&id=dd570700"
import script from "./DailyComponent.vue?vue&type=script&lang=js"
export * from "./DailyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__